<div>
    <p class="title">{{title}}</p>
    <div class="form-group">
        <div class="percent-input">
            <input
            class="input-form-control"
            [(ngModel)]="dvalue"
            placeholder='Insert value'
            [disabled]="disabled"
            
            (ngModelChange)="onValueChanged($event)"
            (focus)="onFocus($event)"
            (blur)='onBlur($event)'>
        </div>
</div>
</div>